<ng-container *ngIf="antwoordResultaat">
  <div class="ols-summary-answer">{{geefAntwoord()}}</div>
</ng-container>
